import { CompositionModelHelper } from "@core/helpers/composition-model.helper";
import { Composition } from "@core/models/composition.model";
import { CompositionsInfo } from "@core/models/compositions-info.model";
import { FundWithRelated } from "@core/models/fund-with-related.model";
import { RiskProfile } from "@core/models/risk-profile.model";
import { createReducer, on } from "@ngrx/store";

import * as compositionModelActions from "./composition-model.actions";

export const COMPOSITION_MODEL_FEATURE_KEY = "compositionModel";

export interface CompositionModelState {
  compositionModelList: Array<Composition>;
  productFundList: Array<FundWithRelated>;
  compositionModelListInfo: CompositionsInfo;
  riskProfilesList: Array<RiskProfile>;
  compositionModel: Composition | null;
  riskProfileExists: boolean;
  loading: boolean;
}

const initialState: CompositionModelState = {
  compositionModelList: [],
  productFundList: [],
  compositionModelListInfo: new CompositionsInfo(),
  riskProfilesList: [],
  compositionModel: null,
  riskProfileExists: false,
  loading: false,
};

export const COMPOSITION_MODEL_REDUCER = createReducer(
  initialState,
  on(
    compositionModelActions.SET_COMPOSITION_MODEL_LIST,
    (
      state: CompositionModelState,
      action: { compositionModelList: Array<Composition> }
    ): CompositionModelState => {
      return {
        ...state,
        compositionModelList: action.compositionModelList,
      };
    }
  ),
  on(
    compositionModelActions.SET_COMPOSITION_MODEL_LOADING_STATUS,
    (
      state: CompositionModelState,
      action: { loading: boolean }
    ): CompositionModelState => {
      return {
        ...state,
        loading: action.loading,
      };
    }
  ),
  on(
    compositionModelActions.SET_COMPOSITION_MODEL_LIST_INFO,
    (
      state: CompositionModelState,
      action: { compositionListInfo: CompositionsInfo }
    ): CompositionModelState => {
      return {
        ...state,
        compositionModelListInfo: action.compositionListInfo,
      };
    }
  ),
  on(
    compositionModelActions.SET_PRODUCT_FUND_LIST,
    (
      state: CompositionModelState,
      action: { productFundList: Array<FundWithRelated> }
    ): CompositionModelState => {
      return {
        ...state,
        productFundList: action.productFundList,
      };
    }
  ),
  on(
    compositionModelActions.SET_RISK_PROFILES_LIST,
    (
      state: CompositionModelState,
      action: { riskProfilesList: Array<RiskProfile> }
    ): CompositionModelState => {
      return {
        ...state,
        riskProfilesList: action.riskProfilesList,
      };
    }
  ),
  on(
    compositionModelActions.CHECK_RISK_PROFILE,
    (
      state: CompositionModelState,
      action: { riskProfileId: string; productId: string }
    ): CompositionModelState => {
      return {
        ...state,
        riskProfileExists: CompositionModelHelper.checkRiskProfileExistence(
          action.riskProfileId,
          action.productId,
          state.compositionModelList
        ),
      };
    }
  ),
  on(
    compositionModelActions.SET_RISK_PROFILE_EXISTS_STATUS,
    (
      state: CompositionModelState,
      action: { riskProfileExists: boolean }
    ): CompositionModelState => {
      return {
        ...state,
        riskProfileExists: action.riskProfileExists,
      };
    }
  ),
  on(
    compositionModelActions.SET_COMPOSITION_MODEL,
    (
      state: CompositionModelState,
      action: { compositionModel: Composition | null }
    ): CompositionModelState => {
      return {
        ...state,
        compositionModel: action.compositionModel,
      };
    }
  )
);
